import React, { useState } from 'react';
import './styles/index.css';
import Page from 'src/components/Page';
import UploadHistory from './UploadHistory';

import { UploadSales } from './UploadSales/UploadSales';

const AudienceView = () => {
  const tabList = ["New upload", "Upload History"];
  const [selectedTab, setSelectedTab] = useState("New upload");

  return (
    <Page title="Sales" className="content-container">
      <div className="content-container-wrapper">
        <div className="audience-content-container">
          <div className="audience-tab-list-container">
            {tabList.map((value, index) => (
              <div key={index} className={`audience-tab-list ${selectedTab === value ? "selected" : ""}`} onClick={() => setSelectedTab(value)}>{value}</div>
            ))}
          </div>
          <div className="audience-content-wrapper">
            {selectedTab === 'New upload'?
              <UploadSales />
            :
              <UploadHistory />
            }
          </div>
        </div>

        <div style={{ minHeight: "40px" }}></div>
      </div>
    </Page>
  );
}

export default AudienceView;